<template>
  <section class="feature fragrance-leaderboards">
    <template v-if="state">
      <h4 class="fragrance-leaderboards-title">Top Selling Fragrances for {{ state.name }}</h4>

      <div class="row">
        <div class="col-md-6">
          <h5 class="leaderboard-name">
            Trending Last 30 Days
          </h5>
          <fragrance-leaderboard :fragrances="state.top_selling_by_monthly_orders" />
        </div>

        <div class="col-md-6">
          <h5 class="leaderboard-name">
            Top Selling For the Past Year
          </h5>
          <fragrance-leaderboard :fragrances="state.top_selling_by_yearly_volume" />
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import FragranceLeaderboard from './fragrance-leaderboard';

  export default {
    components: {
      FragranceLeaderboard
    },
    computed: {
      state() {
        return this.$store.getters.currentState;
      }
    }
  }
</script>
